// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconSuccess::before {
  background-color: rgb(210, 222, 38) !important;
  font-size: 1rem !important;
}

.successModalHeader h2 {
  font-size: 1rem !important;
}

@media only screen and (max-width: 760px) {
  .successModalHeader h2 {
    font-size: 1rem !important;
  }
}
.highlightBox {
  background-color: rgb(235, 235, 236) !important;
}

.card-header {
  color: #53aae5;
  border-block-color: rgb(88, 91, 92);
  font-size: large;
}

.fa-ban:before {
  content: "\\f05e";
  color: red;
  font-size: 4rem;
}

element.style {
  top: 25rem;
}

.modal-content {
  overflow: hidden;
}

.modal-content {
  top: 15rem;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.btn_primary {
  color: #fff;
  border-color: rgb(237, 28, 36);
  background-color: rgb(237, 28, 36);
}

@media only screen and (max-width: 760px) {
  .modal-content {
    top: 17rem;
  }
}
.errorText {
  position: relative;
  top: 5px;
  display: flex;
  justify-content: flex-end;
  color: #ff3d71;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.errorIcon {
  font-size: 1.5rem;
  color: #ff3d71;
  font-style: normal;
  display: flex;
  justify-content: flex-end;
}

.errorIcon::before {
  font-family: "icomoon";
  content: "\\e93e";
  margin-left: 2%;
  display: flex;
  justify-content: flex-end;
}

.highlightBox {
  justify-content: flex-start;
  padding: 10px 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-review-step-form/agent-review-step-form.component.scss"],"names":[],"mappings":"AAAA;EACE,8CAAA;EACA,0BAAA;AACF;;AACA;EACE,0BAAA;AAEF;;AAAA;EACE;IACE,0BAAA;EAGF;AACF;AADA;EACE,+CAAA;AAGF;;AADA;EACE,cAAA;EACA,mCAAA;EACA,gBAAA;AAIF;;AADA;EACE,gBAAA;EACA,UAAA;EACA,eAAA;AAIF;;AADA;EACE,UAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAHA;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;EACA,4BAAA;EACA,oCAAA;EACA,qBAAA;EACA,UAAA;AAMF;;AAJA;EACE,WAAA;EACA,8BAAA;EACA,kCAAA;AAOF;;AAJA;EACE;IACE,UAAA;EAOF;AACF;AAJA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAMF;;AAJA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AAOF;;AALA;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;AAQF;;AALA;EACE,2BAAA;EACA,6BAAA;AAQF","sourcesContent":[".iconSuccess::before {\r\n  background-color: rgb(210, 222, 38) !important;\r\n  font-size: 1rem !important;\r\n}\r\n.successModalHeader h2 {\r\n  font-size: 1rem !important;\r\n}\r\n@media only screen and (max-width: 760px) {\r\n  .successModalHeader h2 {\r\n    font-size: 1rem !important;\r\n  }\r\n}\r\n.highlightBox {\r\n  background-color: rgb(235, 235, 236) !important;\r\n}\r\n.card-header {\r\n  color: #53aae5;\r\n  border-block-color: rgb(88, 91, 92);\r\n  font-size: large;\r\n}\r\n\r\n.fa-ban:before {\r\n  content: '\\f05e';\r\n  color: red;\r\n  font-size: 4rem;\r\n}\r\n\r\nelement.style {\r\n  top: 25rem;\r\n}\r\n.modal-content {\r\n  overflow: hidden;\r\n}\r\n.modal-content {\r\n  top: 15rem;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  pointer-events: auto;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid rgba(0, 0, 0, 0.2);\r\n  border-radius: 0.3rem;\r\n  outline: 0;\r\n}\r\n.btn_primary {\r\n  color: #fff;\r\n  border-color: rgb(237, 28, 36);\r\n  background-color: rgb(237, 28, 36);\r\n}\r\n\r\n@media only screen and (max-width: 760px) {\r\n  .modal-content {\r\n    top: 17rem;\r\n  }\r\n}\r\n\r\n.errorText {\r\n  position: relative;\r\n  top: 5px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  color: #ff3d71;\r\n  font-size: 1rem;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.errorIcon {\r\n  font-size: 1.5rem;\r\n  color: #ff3d71;\r\n  font-style: normal;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n.errorIcon::before {\r\n  font-family: 'icomoon';\r\n  content: '\\e93e';\r\n  margin-left: 2%;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.highlightBox {\r\n  justify-content: flex-start;\r\n  padding: 10px 10px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
